import axios from "axios";
import {ordersServicesPath} from "../../../../Constants";

const planServiceRestUrl = ordersServicesPath + '/organizations/plans'

export default class PlanService {

    static async getAllNotArchive() {
        return axios.get(planServiceRestUrl + '/not-archive', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(id) {
        await axios.delete(planServiceRestUrl + '/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async createPlan(data) {
        return await axios.post(planServiceRestUrl,
            JSON.stringify(data), {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }

    static async unableStatus(id, planState) {
        return axios.patch(planServiceRestUrl + '/' + id + '/unable-status?planState=' + planState, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async edit(id, data) {
        return axios.put(planServiceRestUrl + '/' + id, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}